module.exports = __webpack_public_path__ + "static/cortex-about-dretti-min-9fcc8faf087784b033128c91701dfaaa.png";